{
  "name": "fuse-financial-frontend",
  "description": "Frontend for the FuSE Financial platform",
  "version": "1.0.0",
  "private": true,
  "author": "FuSE",
  "engines": {
    "node": "^18.16.0"
  },
  "scripts": {
    "build": "parcel build public/index.html",
    "dev": "DEBUG=fuse* parcel public/index.html",
    "dev:clean": "yarn clean && yarn dev",
    "start": "parcel public/index.html",
    "lint": "eslint src --ext .ts,.tsx --max-warnings 0",
    "lint:fix": "eslint src --ext .ts,.tsx --fix",
    "format": "prettier --write \"src/**/*.{ts,tsx,js,jsx,json,md}\"",
    "check-format": "prettier --check \"src/**/*.{ts,tsx,js,jsx,json,md}\"",
    "clean": "rm -rf .parcel-cache dist"
  },
  "browserslist": "> 0.5%, last 2 versions, not dead",
  "dependencies": {
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.0",
    "@mui/icons-material": "^6.4.6",
    "@mui/material": "^6.4.6",
    "animate.css": "^3.4.0",
    "d3": "4",
    "d3-tip": "^0.9.1",
    "dayjs": "^1.11.10",
    "debug": "^4.3.4",
    "lodash": "^4.17.21",
    "materialize-css": "0.97.8",
    "mobx": "^6.9.0",
    "mobx-react-lite": "^3.4.3",
    "react": "^18.0.0",
    "react-dom": "^18.0.0",
    "react-error-boundary": "^6.0.0",
    "react-number-format": "^5.4.4",
    "react-router-dom": "^6.11.2",
    "react-toastify": "^9.1.2"
  },
  "devDependencies": {
    "@parcel/css": "^1.14.0",
    "@parcel/transformer-svg-react": "^2.8.3",
    "@trivago/prettier-plugin-sort-imports": "^4.1.1",
    "@types/debug": "^4.1.12",
    "@types/lodash": "^4.17.18",
    "@types/node": "20.1.2",
    "@types/react": "^18.0.0",
    "@types/react-dom": "^18.2.4",
    "@typescript-eslint/eslint-plugin": "^5.59.6",
    "@typescript-eslint/parser": "^5.59.6",
    "assert": "^2.0.0",
    "buffer": "^5.5.0||^6.0.0",
    "console-browserify": "^1.2.0",
    "eslint": "8.40.0",
    "eslint-config-prettier": "^10.0.1",
    "eslint-plugin-jsx-a11y": "^6.7.1",
    "eslint-plugin-prettier": "^5.5.4",
    "eslint-plugin-react": "^7.37.4",
    "eslint-plugin-react-hooks": "^4.6.0",
    "parcel": "^2.10.2",
    "prettier": "^2.8.8",
    "process": "^0.11.10",
    "timers-browserify": "^2.0.11",
    "typescript": "5.0.4"
  }
}
